'use client';

import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import Script from 'next/script';
import { JSX, PropsWithChildren, ReactNode, useState } from 'react';

import { useBraintreeDeviceData } from './useBraintreeDeviceData';

export interface RecurlyCheckoutWrapperProps {
    children: ReactNode;
    publicKey: string;
}

export default function RecurlyCheckoutWrapper({
    publicKey,
    children,
}: PropsWithChildren<RecurlyCheckoutWrapperProps>): JSX.Element {
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const braintreeDeviceData = useBraintreeDeviceData();
    const readyToConfigure = scriptLoaded && braintreeDeviceData.status === 'ready';
    const fraud =
        braintreeDeviceData.status === 'ready' && braintreeDeviceData.deviceData
            ? { braintree: { deviceData: braintreeDeviceData.deviceData } }
            : undefined;

    return (
        <div>
            <Script src="https://js.recurly.com/v4/recurly.js" onLoad={() => setScriptLoaded(true)} />
            {/* // Waiting for the script ensures these components will not load until after the necessary Recurly Script in the layout. */}
            {readyToConfigure && (
                // All components that use data from Recurly need to be encapsulated in Recurly's client-side wrapper.
                <RecurlyProvider publicKey={publicKey} required={['cvv']} fraud={fraud}>
                    <Elements>{children}</Elements>
                </RecurlyProvider>
            )}
        </div>
    );
}
